export default __webpack_public_path__ + "static/media/typeplane.cee3abc4.svg";